"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _LockClosed = _interopRequireDefault(require("@insided/destination/icons/LockClosed"));

var _PlusInCircle = _interopRequireDefault(require("@insided/destination/icons/PlusInCircle"));

var _Time = _interopRequireDefault(require("@insided/destination/icons/Time"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var PrivateGroupPlaceholder = function PrivateGroupPlaceholder(_ref) {
  var isLoading = _ref.isLoading,
      onRequest = _ref.onRequest,
      requestPending = _ref.requestPending;
  return (0, _preact.h)("div", {
    className: "group-private__placeholder groups-v2-styles"
  }, (0, _preact.h)("div", {
    className: "group-content-container"
  }, !requestPending && (0, _preact.h)("div", null, (0, _preact.h)(_LockClosed.default, {
    className: "icon-locked"
  }), (0, _preact.h)("h3", null, (0, _preact.h)(_phrase.default, {
    p: "groups.information.private.title"
  })), (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
    p: "groups.information.private.description"
  })), (0, _preact.h)("div", {
    className: "group-private__call-to-action"
  }, (0, _preact.h)(_Button.default, {
    type: "button",
    className: "btn--cta btn",
    isLoading: isLoading,
    onClick: onRequest,
    oldStyle: true,
    "data-bounded-context": "Groups",
    "data-entity": "group-request-to-join",
    "data-track-type": "click",
    "data-element-name": "Group Clicked Request to join"
  }, (0, _preact.h)(_PlusInCircle.default, {
    className: "icon-plus"
  }), (0, _preact.h)(_phrase.default, {
    p: "groups.request.to.join"
  })))), requestPending && (0, _preact.h)("div", null, (0, _preact.h)(_Time.default, {
    className: "icon-clockDestination"
  }), (0, _preact.h)("h3", null, (0, _preact.h)(_phrase.default, {
    p: "groups.information.applied.title"
  })), (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
    p: "groups.information.applied.description"
  })))));
};

var _default = PrivateGroupPlaceholder;
exports.default = _default;